import SvgIcon, {type SvgIconProps} from '@mui/material/SvgIcon';

const Edit = (props : SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 15.548 15.548">
      <g id="Groupe_36" data-name="Groupe 36" transform="translate(3.561 14.841) rotate(-135)">
        <path id="Tracé_6252" data-name="Tracé 6252" d="M0,3.454v12.5H4.036V3.454L2,0Z" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"/>
        <path id="Tracé_6253" data-name="Tracé 6253" d="M3.551,0H0" transform="translate(0.243 6.008)" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1"/>
        <path id="Tracé_6255" data-name="Tracé 6255" d="M9.552,0H0" transform="translate(2.018 6.008) rotate(90)" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1"/>
        <path id="Tracé_6254" data-name="Tracé 6254" d="M1.837,0H0" transform="translate(1.1 2.008)" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1"/>
      </g>
    </svg>
  </SvgIcon>
);

export default Edit;